import { render } from "./AggreementContent.vue?vue&type=template&id=23d86d77"
import script from "./AggreementContent.vue?vue&type=script&lang=js"
export * from "./AggreementContent.vue?vue&type=script&lang=js"

import "./AggreementContent.vue?vue&type=style&index=0&id=23d86d77&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__